import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { buildGroups, isPathActive } from './fioriNav';
import { useLanguage } from '../../contexts/LanguageContext';

// Mobile Off-Canvas-Navigation (ersetzt Top-Nav unter 1024px).
export default function FioriMobileNav({ open, onClose, user, badges = {} }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const groups = buildGroups(t, user);

  const go = (path) => { navigate(path); onClose(); };
  const badgeFor = (item) => (item.badgeKey ? (badges[item.badgeKey] || 0) : 0);

  return (
    <>
      <div className={`fs-drawer-overlay ${open ? 'open' : ''}`} onClick={onClose} data-testid="fiori-drawer-overlay" />
      <aside className={`fs-drawer ${open ? 'open' : ''}`} role="navigation" aria-label={t('fiori.nav.mobile', 'Mobile Navigation')} data-testid="fiori-mobile-nav">
        <div className="flex items-center justify-between px-2 pb-1">
          <span className="fs-brand-word" style={{ fontSize: 16 }}>QM8D<b>.ai</b></span>
          <button className="fs-icon-btn" onClick={onClose} aria-label={t('common.close', 'Schließen')} data-testid="fiori-mobile-close">
            <X size={18} />
          </button>
        </div>
        {groups.map((g) => (
          <div key={g.id}>
            <div className="fs-drawer-group-label">{g.label}</div>
            {g.home ? (
              <div
                className={`fs-drawer-link ${location.pathname === '/home' ? 'active' : ''}`}
                onClick={() => go(g.home)} role="button" tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(g.home); } }}
                data-testid={`fiori-mobile-link-${g.id}`}
              >
                {t('nav.dashboard', 'Dashboard')}
              </div>
            ) : (
              g.items.map((item) => {
                const Icon = item.icon;
                const badge = badgeFor(item);
                return (
                  <div
                    key={item.path}
                    className={`fs-drawer-link ${isPathActive(item.path, location) ? 'active' : ''}`}
                    onClick={() => go(item.path)} role="button" tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(item.path); } }}
                    data-testid={`fiori-mobile-link-${item.path.replace(/[/?=]/g, '-').replace(/^-/, '')}`}
                  >
                    {Icon && <Icon />}
                    <span>{item.label}</span>
                    {badge > 0 && <span className="fs-nav-badge" style={{ marginLeft: 'auto' }}>{badge}</span>}
                  </div>
                );
              })
            )}
          </div>
        ))}
      </aside>
    </>
  );
}
